import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const TABS = [
  { id: 'home',      label: 'Home',                defaultRoute: '/dashboard' },
  { id: 'family',    label: 'Family',              defaultRoute: '/grocery' },
  { id: 'finances',  label: 'Financial Management', defaultRoute: '/bills' },
  { id: 'resources', label: 'Resources',           defaultRoute: '/knowledge-base' },
  { id: 'admin',     label: 'Admin',               defaultRoute: '/household' },
];

const ROUTE_TO_TAB = {
  '/dashboard':                  'home',
  '/grocery':                    'family',
  '/todo':                       'family',
  '/wishlist':                   'family',
  '/appointments':               'family',
  '/appointments/calendar':      'family',
  '/bills':                      'finances',
  '/subscriptions':              'finances',
  '/debts':                      'finances',
  '/assets':                     'finances',
  '/knowledge-base':             'resources',
  '/recipes':                    'resources',
  '/web-links':                  'resources',
  '/passwords':                  'resources',
  '/household':                  'admin',
  '/admin/household':            'admin',
  '/admin/knowledge-categories': 'admin',
  '/admin/super':                'admin',
};

function TopTabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = ROUTE_TO_TAB[location.pathname] || 'home';

  return (
    <div className="top-tab-bar">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          className={`top-tab-item ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => navigate(tab.defaultRoute)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default TopTabBar;
export { ROUTE_TO_TAB };
